<ot-address
  *ngIf="group"
  [group]="group.get(config.field)"
  [full]="config.full"
  [errors]="errors"
  [hideCountry]="config.hideCountry"
  [required]="config.required"
  [dealType]="config.dealType"
></ot-address>
